import React from "react";

const ArrowPrev = () => {
  return (
    <div className="arrow-prev">
      <svg width="23px" height="17px" viewBox="0 0 23 17" version="1.1">
        <g
          id="exports"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Desktop"
            transform="translate(-500.000000, -503.000000)"
            stroke="#000000"
            strokeWidth="2"
          >
            <g
              id="arrow-prev"
              transform="translate(512.000000, 511.500000) scale(-1, 1) translate(-512.000000, -511.500000) translate(502.000000, 504.000000)"
            >
              <polyline
                id="Path-2"
                transform="translate(16.842105, 7.500000) scale(-1, -1) rotate(90.000000) translate(-16.842105, -7.500000) "
                points="9.34210526 4.34210526 16.8421053 10.6578947 24.3421053 4.34210526"
              ></polyline>
              <line
                x1="19.0601504"
                y1="7.46173469"
                x2="0.488721805"
                y2="7.46173469"
                id="Line-2"
                strokeLinecap="square"
              ></line>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default ArrowPrev;
